import FileViewerModal from "./FileViewerModal";

export default FileViewerModal;
